<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import accidentAPI from "@/services/standards/accident/accidentAPI";
import medicionAusentismoAPI from "@/services/standards/medicionAusentismo/medicionAusentismoAPI";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI"
import { sendNotification } from "@/utils/helpers/notification"
import CheckModal from "@/components/CheckModal"
import ItemAPI from "@/services/items/itemsAPI";
import CompanyAPI from "@/services/company/companyAPI";
import EmployeeAPI from "@/services/employee/employeeAPI";
import { required } from 'vuelidate/lib/validators'
/**
 * Form elements component
 */
export default {
  page: {
    title: "3.3.6 Medición del ausentismo por causa médica",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
  },
  data() {

    return {
      submi: false,
      title: "3.3.6 Medición del ausentismo por causa médica",
      items: [

        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "3.3.6 Medición del ausentismo por causa médica",
        },
        {
          text: "Ver",
          active: true,
        },
      ],

      information: true,
      lista: [],
      type: [],
      typeEvent: [],
      lesion: [],
      agente: [],
      parteAfectada: [],
      subtype: [],
      listaII: [],

      file: null,

      item: null,
      loading1: true,
      itemData: null,

      medicion: {
        start_date: null,
        final_date: null,
        inability_type: null,
        extension: null,
        days_disability: null,
        file: null,
        diagnostic_code_id: null,
        description4_codes: null,
        employee_id: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },
      submitted: false,
      select: null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      usersList: [],
      exist: false,
      cantidad: false,
      search: "",
      loading: true,
    };
  },

  validations: {
    accident: {
      accident_report_types_id: {
        required,
      },
      report_date: {
        required,
      },
      hour: {
        required,
      },
      description: {
      },
      improvement_plan: {
      },
      arl_report_date: {
      },
      site: {
        required,
      },
      file: {
      },
      employee_id: {
        required,
      },
    },
  },
  methods: {

    fetch() {
      this.loading = true;
      this.$refs.paginator.query();
    },

    getItem() {
      CompanyItemsAPI.getStatus(this.companyID, 40)
        .then(response => {
          this.exist = response.id
        })
        .catch(error => {
          console.log(error)
        })
    },

    getAccidents() {
      accidentAPI.getAllAccidents(this.companyID)
        .then((response) => {
          this.cantidad = response.Accident_report
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getUsers() {
      CompanyAPI.getCompany(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          EmployeeAPI.getEmployeesOcupationalMedical(response.id)
            .then((res) => {
              this.usersList = res.employee
            })

        })
        .catch((error) => {
          console.log(error);
        });

    },

    getItemData() {
      ItemAPI.getItems(40)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 40)
        .then(response => {
          this.item = response || null
        })
        .catch(error => {
          console.log(error)
        })
    },

    /**
        * This method is used to send notification to SST user and SST company.
        * The sendNotification method import is required.
        * @param {Number} messageID - The message ID that will be associated to notification.
        * @param {Number} itemID - The item ID that will be associated to notification.
        * @param {Boolean} user - The user that will e associated to notification.
        * @return {Boolean} True if the notification is sent, false if not.
        */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },


    /**
    * This method is used to knows if the user has the permission indicated
    * @param {String} name The name of the permission
    * @param {Array} roles the roles that permitted to access the action 
    * @returns {Boolean} true if the user has the permission indicated or false if no
    */
    getRole(name, roles) {

      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null

      // If the user is logged
      if (role) {

        // If the roles array is not empty
        if (roles) {

          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false

        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {

          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8

        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions

        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false

      } // Close if the user is logged

      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

    /**
   * This method is used to redirect to the page indicated
   * @param {String} page The page to redirect
  */
    goPage(page) {
      window.location.href = page
    },

    getType() {
      accidentAPI.getType()
        .then((response) => {
          this.type = response.Accident_report_type;
        })
        .catch((error) => {
          console.log(error);

        });
    },

    getSubType() {
      accidentAPI.getType()
        .then((response) => {
          let typeAccident = response.Accident_report_type;
          this.type = typeAccident
          this.subtype = typeAccident[0].report_subtype
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getTypeEvent() {
      accidentAPI.getTypeEvent()
        .then((response) => {
          this.typeEvent = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    gettypeOfInjury() {
      accidentAPI.gettypeOfInjury()
        .then((response) => {
          this.lesion = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getAccidentAgent() {
      accidentAPI.getAccidentAgent()
        .then((response) => {
          this.agente = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getInjuredPartBody() {
      accidentAPI.getInjuredPartBody()
        .then((response) => {
          this.parteAfectada = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getShow() {
      medicionAusentismoAPI
        .getShow(this.$route.params.id)
        .then((response) => {
          this.medicion = {
            start_date: response.data.start_date,
            final_date: response.data.final_date,
            inability_type: response.data.inability_type,
            extension: response.data.extension,
            days_disability: response.data.days_disability,
            file: response.data.file,
            diagnostic_code_id: response.data.diagnostic_code_id,
            description4_codes: response.data.description4_codes,
            employee_id: response.data.employee_id,
            companies_id: response.data.companies_id,
          };
          this.loading = false
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getList() {
      medicionAusentismoAPI.getAll(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          this.lista = response.data.data;
          this.loading1 = false
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

  },

  mounted() {
    this.getAccidents()
    this.getUsers();
    this.getItems()
    this.getItem()
    this.getList();
    this.getItemData();
    this.getType();
    this.getSubType();
    this.getTypeEvent();
    this.gettypeOfInjury();
    this.getAccidentAgent();
    this.getInjuredPartBody();
    this.getShow();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading1">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-12 text-right m-b-0">
                  <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                  <b-tooltip target="back" placement="left"> Volver </b-tooltip>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-md-6 col-sm-12">

                  <CheckModal>
                    <p class="text-justify">
                      Este indicador mide la pérdida de días programados de trabajo en el mes por incapacidad médica.
                    </p>
                    <p class="text-justify">
                      Los días programados de trabajo al mes corresponden a la cantidad de días laborales en el mes por
                      el número de trabajadores.
                    </p>
                    <p class="text-justify">
                      El responsable de la implementación deberá definir la meta mensual y anual, además el responsable
                      de la medición y las personas que deben conocer el resultado.
                    </p>
                  </CheckModal>
                </div>

                <div class="col-6 text-right m-b-0">

                </div>

              </div>

              <form :disabled="!getRole('Crear') || !allowAccess()" class="form-group" @submit.prevent="save">

                <div>

                  <div class="form-row pt-3  px-3">
                    <b-form-group class="col-md-6" label="Colaborador" label-for="employee">
                      <select disabled id="employeeID" class="form-control" v-model="medicion.employee_id">
                        <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                          {{ item.full_name }}
                        </b-form-select-option>

                      </select>

                    </b-form-group>

                    <b-form-group label="Tipo de enfermedad" required label-for="tipo" inline class="col-sm-6 pl-4">
                      <div>

                        <label class="mr-2 mt-1">
                          Accidente de trabajo
                        </label>
                        <input :disabled="!getRole('Crear') || !allowAccess()" type="radio" style="color: #666"
                          value="Accidente_de_trabajo" disabled v-model="medicion.inability_type"
                          class="mb-2 mr-sm-2 mb-sm-0  mt-1" label="accidente" />
                        <label class="mr-2 pl-sm-2 pl-md-0  mt-1">
                          Enfermedad general
                        </label>
                        <input :disabled="!getRole('Crear') || !allowAccess()" type="radio" value="Enfermedad_general"
                          v-model="medicion.inability_type" disabled class="mb-2 mr-sm-2 mb-sm-0" label="incidente" />
                        <label class="mr-2 pl-sm-2 pl-md-0  mt-1">
                          Enfermedad laboral
                        </label>
                        <input :disabled="!getRole('Crear') || !allowAccess()" type="radio" value="Enfermedad_laboral"
                          v-model="medicion.inability_type" disabled class="mb-2 mr-sm-2 mb-sm-0  mt-1"
                          label="enfermedad" />
                      </div>

                    </b-form-group>


                  </div>


                  <div class="form-row pt-3 px-3">

                    <b-form-group class="col-md-6" label="Fecha inicio" label-for="trainingDate">
                      <b-form-input disabled type="date" id="trainingDate" v-model="medicion.start_date">
                        >
                      </b-form-input>

                    </b-form-group>

                    <b-form-group class="col-md-6" label="Fecha fin" label-for="trainingDate">
                      <b-form-input disabled type="date" id="trainingDate" v-model="medicion.final_date">
                        >
                      </b-form-input>

                    </b-form-group>


                  </div>

                  <div class="form-row pt-3  px-3">

                    <b-form-group class="col-md-3" label="Código diagnóstico" label-for="input-sm">
                      <b-form-input type="text" maxlength="100" disabled id="textarea"
                        v-model="medicion.description4_codes" rows="4"></b-form-input>
                    </b-form-group>

                    <b-form-group class="col-md-3" label="Días de incapacidad" label-for="input-sm">
                      <b-form-input type="number" maxlength="100" disabled id="textarea"
                        v-model="medicion.days_disability" rows="4"></b-form-input>
                    </b-form-group>

                    <b-form-group label="Prórroga" label-for="¿Evaluada el ultimo año?" inline
                      class="col-md-6 pl-5 pt-2">
                      <label class="mr-2">
                        Si
                      </label>
                      <input type="radio" disabled style="color: #666" value="SI" v-model="medicion.extension"
                        class="mb-2 mr-sm-2 mb-sm-0" label="accidente" />
                      <label class="mr-2 pl-sm-2 pl-md-0">
                        No
                      </label>
                      <input type="radio" disabled value="NO" class="mb-2 mr-sm-2 mb-sm-0" label="incidente"
                        v-model="medicion.extension" />

                    </b-form-group>

                  </div>

                  <div class="form-row px-3">

                    <b-form-group class="col-md-12 px-2" label="Descargar archivo" label-for="file">
                      <button class="ml-4" led="!allowAccess()"
                        style=" background-color: transparent !important; border: none;" type="button"
                        @click="gotoDigitalOcean(`${medicion.file}`)"> <i class="mdi mdi-cloud-download"></i>
                      </button>

                    </b-form-group>
                  </div>


                </div>

              </form>
            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>


      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>